const strings = {
  en: {
    navLinks: [
      { id: 'home', label: 'Home' },
      { id: 'product', label: 'Product', hasDropdown: true },
      { id: 'pricing', label: 'Pricing' },
      { id: 'about', label: 'About' },
      { id: 'contact', label: 'Contact' },
      { id: 'download', label: 'Download' },
    ],
    productDropdownItems: [
      { icon: '\u{1F4DD}', title: 'Meeting Minute', desc: 'AI-generated notes & summaries', page: 'feature-meeting-minute' },
      { icon: '\u{1F4CB}', title: 'Survey Form', desc: 'Create & analyze surveys', page: 'feature-survey-form' },
      { icon: '\u{1F3C6}', title: 'AI Coaching', desc: 'Personalized sales coaching', page: 'feature-ai-coaching' },
      { icon: '\u{1F4DA}', title: 'Training Needs', desc: 'Skill gap analysis', page: 'feature-training-needs' },
      { icon: '\u{1F3A7}', title: 'Audio Playback', desc: 'Review recorded conversations', page: 'feature-audio-playback' },
      { icon: '\u{1F4CD}', title: 'Location', desc: 'Real-time GPS tracking', page: 'feature-location' },
      { icon: '\u{1F4CA}', title: 'Performance Scoring', desc: 'Structured evaluation', page: 'feature-performance-scoring' },
      { icon: '\u{1F527}', title: 'Customization', desc: 'Configure your workflow', page: 'feature-customization' },
      { icon: '\u{1F4AC}', title: 'Follow-up', desc: 'Automated WhatsApp & email', page: 'feature-follow-up' },
      { icon: '\u{1F4C9}', title: 'Traffic Analytics', desc: 'Performance trends & insights', page: 'feature-traffic-analytics' },
    ],
    getStartedFree: 'Book Free Demo',
    goToApp: 'Go to App',
    toggleMenu: 'Toggle menu',
    closeMenu: 'Close menu',
    languageToggleLabel: 'Switch language',
  },
  zh: {
    navLinks: [
      { id: 'home', label: '首页' },
      { id: 'product', label: '产品', hasDropdown: true },
      { id: 'pricing', label: '价格' },
      { id: 'about', label: '关于我们' },
      { id: 'contact', label: '联系我们' },
      { id: 'download', label: '下载' },
    ],
    productDropdownItems: [
      { icon: '\u{1F4DD}', title: '会议纪要', desc: 'AI 自动生成记录与摘要', page: 'feature-meeting-minute' },
      { icon: '\u{1F4CB}', title: '调研问卷', desc: '创建并分析问卷', page: 'feature-survey-form' },
      { icon: '\u{1F3C6}', title: 'AI 辅导', desc: '个性化销售辅导', page: 'feature-ai-coaching' },
      { icon: '\u{1F4DA}', title: '培训需求', desc: '技能差距分析', page: 'feature-training-needs' },
      { icon: '\u{1F3A7}', title: '录音回放', desc: '复盘客户对话', page: 'feature-audio-playback' },
      { icon: '\u{1F4CD}', title: '位置追踪', desc: '实时 GPS 定位', page: 'feature-location' },
      { icon: '\u{1F4CA}', title: '绩效评分', desc: '结构化评估体系', page: 'feature-performance-scoring' },
      { icon: '\u{1F527}', title: '灵活定制', desc: '按需配置工作流程', page: 'feature-customization' },
      { icon: '\u{1F4AC}', title: '客户跟进', desc: '自动化 WhatsApp 与邮件', page: 'feature-follow-up' },
      { icon: '\u{1F4C9}', title: '流量分析', desc: '业绩趋势与洞察', page: 'feature-traffic-analytics' },
    ],
    getStartedFree: '预约免费演示',
    goToApp: '前往应用',
    toggleMenu: '切换菜单',
    closeMenu: '关闭菜单',
    languageToggleLabel: '切换语言',
  },
};

export default strings;
